import { Injectable } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { ImageDTO } from '../user/models/imageDTO';
import { saveAs } from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  constructor(private route:ActivatedRoute, private sanitizer: DomSanitizer) { }

  public handleFilterInitialization(callback: Function): void {
    this.route.queryParams.subscribe(params => {
      if (params['filter'] === 'on') {
        callback(true);
      } else {
        callback(false);
      }
    });
  }

  public compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    if (a && b) { return (a < b ? -1 : 1) * (isAsc ? 1 : -1); }
    if (a && !b) { return -1 * (isAsc ? 1 : -1); }
    if (!a && b) { return 1 * (isAsc ? 1 : -1); }
    if (!a && !b) { return 0; }
  }

  public createUrlFromArrayBuffer(image: ImageDTO) {
    return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(new Blob([image.imageDataDownload], {type: 'image/png'})));
  }

  public downloadFile(event: any, image: ImageDTO) {
    switch (event.name) {
      case 'download':
        saveAs(new Blob([image.imageDataDownload]), image.imageName + '.' + image.extension);
        break;
    }
  }

  public getImage(image: ImageDTO) {
    return "data:image/"+ image.extension + ";base64," + image.imageData;
  }
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'DD/MM/YYYY'
  }
};

/** Size in bytes (octets) */
export function convertFileSize(aSize) {
  aSize = Math.abs(parseInt(aSize, 10));
  let def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']];
  for (let i=0; i < def.length; i++) {
    if (aSize < def[i][0]) return +((aSize / +def[i-1][0]).toFixed(2)) + ' ' + def[i-1][1];
  }
}

/** Calculate ratio on an image by width and height */
export function getAspectRatio(width: number, height: number): string {
  const calculate = (a: number, b: number): number =>
    b === 0 ? a : calculate(b, a % b);

  return `${width / calculate(width, height)}:${
    height / calculate(width, height)
  }`;
}

/** Transform File to Image element */
export function readFile(file: File): HTMLImageElement {

  if (!file) {
    return null;
  }

  const image = new Image();
  const reader = new FileReader();

  reader.readAsDataURL(file);
  reader.onload = () => {
    const result = reader?.result;
    if (!result) {
      return null;
    }

    image.src = result as string;
  };

  return image;
}
